"use strict";

var debounce = require("lodash/debounce");
var Masonry = require("masonry-layout");
let checkInView = () => {
    var elements;
    var windowHeight;

    let init = () => {
        elements = document.querySelectorAll(".m-product-launch-section");

        for (var i = 0; i < elements.length; i++) {
            if (i !== 0) {
                elements[i].classList.add("m-product-launch-section-hidden");
            }
        };

        windowHeight = window.innerHeight;
    };

    let checkPosition = () => {
        for (var i = 0; i < elements.length; i++) {
            let positionFromTop = elements[i].getBoundingClientRect().top;
            let value = -100;
            if (window.mqRespond.status.smUp) {
                value = -170;
            } else {
                if (window.mqRespond.status.mdUp) {
                    value = -230;
                }
            }

            if (positionFromTop - windowHeight <= value && i !== 0) {
                elements[i].classList.add("m-product-launch-section-fade-in-element");
                elements[i].classList.remove("m-product-launch-section-hidden");
            }
        };
    };

    window.addEventListener("scroll", checkPosition);

    init();
    checkPosition();
};

let benefitsBlockInit = () => {
    let $description = $(".sticky-description");
    let parentSection = $description.closest(".m-product-launch-section__benefit-block");
    if (parentSection) {
        let qTop = 0;

        if (window.mqRespond.status.mdOnly) {
            qTop = window.innerHeight / 2 - 150;
        }

        let testInView = ($el) => {
            let wTop = $(window).scrollTop();
            let wBot = wTop + $(window).height();
            let eTop = $el.offset().top;
            let eBot = eTop + $el.height() + qTop;
            return ((eBot <= wBot) && (eTop >= wTop));
        };

        let setInView = () => {
            let visible = false;
            $(".benefit-image").each(function () {
                let $this = $(this);
                let currentDescriptionText = $description.html();
                if (testInView($this)) {
                    $(".benefit-image").removeClass("is-in-view");
                    let textDescription = $this.closest(".m-product-launch-section__benefit-tile").find(".benefit-description").html();
                    if (currentDescriptionText !== textDescription) {
                        $description.hide().html(textDescription).fadeIn(700);
                    }
                    $this.addClass("is-in-view");
                    visible = true;
                } else {
                    $this.removeClass("is-in-view");
                }
            });
            if (visible) {
                $description.removeClass("d-none");
            } else {
                $description.addClass("d-none");
            }
        };

        let stickyHeaderTop = $(".l-header").height();
        let nextSection = parentSection.next(".m-product-launch-section");
        let firstItem = $(".m-product-launch-section__benefit-tile.first");
        let textDescription = firstItem.find(".benefit-description").html();
        firstItem.find($(".benefit-image")).addClass("is-in-view");
        $description.html(textDescription);

        let top = "170px";
        let headerValue = 0;

        if (window.mqRespond.status.mdOnly) {
            top = "20%";
            headerValue = 170;
        }

        let changeDescription = () => {
            if (parentSection.offset()) {
                var $window = $(window);

                if ($window.scrollTop() > (parentSection.offset().top - stickyHeaderTop - headerValue)) {
                    $description.css({position: "fixed", top: top, left: $window.width() / 2, right: "20px"});
                    setInView();
                } else {
                    $description.css({position: "absolute", top: "0px", left: "0px"});
                }

                if ($window.scrollTop() > nextSection.offset().top - $window.height() / 2 - 230) {
                    $description.css({position: "absolute", bottom: "80px", top: "auto", left: "0px"});
                }
            }
        };

        window.addEventListener("scroll", debounce(function () {
            changeDescription();
        }));

        $(window).resize(function () {
            setInView();
            changeDescription();
        });
    }
};

let playVideoIframeInPopup = () => {
    let tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    let firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    let $modalVideos = $(".video-layer-wrapper");

    let playerConfig = {};

    let queue = {
        content: null,
        push(fn) {
            this.content = fn;
        },
        pop() {
            this.content.call();
            this.content = null;
        }
    };

    let player;

    window.onYouTubeIframeAPIReady = () => {
        player = new YT.Player("video", {
            videoId: "video",
            playerVars: playerConfig,
            events: {
                "onReady": onPlayerReady
            }
        });
    };

    // API event: when the player is ready, call the function in the queue
    let onPlayerReady = () => {
        if (queue.content) queue.pop();
    };

    // Helper function to check if the player is ready
    let isPlayerReady = (player) => {
        return player && typeof player.playVideo === "function";
    };

    $modalVideos.each(function () { 
        let $this = $(this);
        let $videoBlock = $this.find(".video-iframe");
        let $modalOverlay = $(".l-overlay");
        let $playBtn = $this.find("[data-play]");
        let $modalVideo = $("[data-modal-video]");
        let $closeVideoBtn = $(".video-layer").find("[data-close-video]");
        var $el = $this.find("#video").clone();
        $modalVideo.append($el);

        // Instead of calling player.playVideo() directly,
        // using this function to play the video.
        // If the player is not ready, queue player.playVideo() and invoke it when the player is ready
        let playVideo = (player) => {
            let $el = $videoBlock.clone();
            $modalVideo.append($el);
            let video = $modalVideo.find(".video-iframe");
            video[0].src += "&autoplay=1&mute=1";
            if (video[1]) {
                video[1].remove();
            }
            isPlayerReady(player) ? player.playVideo() : queue.push(() => {
                player.playVideo();
            });
        };

        let showVideoLayer = () => {
            $modalOverlay.removeClass("d-none").addClass("full-height");
            $modalVideo.addClass("show");
            playVideo(player);
        };

        let hideVideoOverlay = () => {
            $modalVideo.removeClass("show").empty();
            $modalOverlay.addClass("d-none").removeClass("full-height");
            $videoBlock.attr("src", $videoBlock.attr("src"));
            return false;
        };

        $closeVideoBtn.on("click touchstart", (e) => {
            e.preventDefault();
            hideVideoOverlay(player);
        });

        $playBtn.on("click", (e) => {
            showVideoLayer();
        });

        if ($modalOverlay) {
            $modalOverlay.on("click", function (e) {
                e.preventDefault();
                hideVideoOverlay(player);
            });
        }

        let parseUrl = (url) => {
            const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
            if (url) {
                let match = url.match(regExp);
                return (match && match[7].length == 11) ? match[7] : false;
            }
        };

        let videoID = $videoBlock.attr("src");
        let parsedID = parseUrl(videoID);
        let parsedAlt = $videoBlock.attr("alt");

        return $this.find(".overlay-iframe").empty().append(`<img src="https://i.ytimg.com/vi/${parsedID}/sddefault.jpg" alt="${parsedAlt} "/>`);
    });
};

let playVideoIframe = () => {
    let tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    let firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    let playerConfig = {};

    let queue = {
        content: null,
        push(fn) {
            this.content = fn;
        },
        pop() {
            this.content.call();
            this.content = null;
        }
    };

    let player;

    window.onYouTubeIframeAPIReady = () => {
        player = new YT.Player("legacyFilm", {
            videoId: "legacyFilm",
            playerVars: playerConfig,
            events: {
                onReady: onPlayerReady
            }
        });
    };

    // API event: when the player is ready, call the function in the queue
    let onPlayerReady = () => {
        if (queue.content) queue.pop();
    };

    // Helper function to check if the player is ready
    let isPlayerReady = (player) => {
        return player && typeof player.playVideo === "function";
    };

    let parseUrl = (url) => {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        if (url) {
            const match = url.match(regExp);
            return (match && match[7].length == 11) ? match[7] : false;
        }
    };

    let videoPlayButton = $("[data-video-play]");

    videoPlayButton.each(function () {
        const $this = $(this);
        let $videoBlock = $this.parent().parent().parent().find(".legacy-film");
        let $elementAncestor = $this.parent().parent();

        $this.on("click", (e) => {
            e.preventDefault();

            $elementAncestor.addClass("d-none");
            $elementAncestor.find(".overlay-legacy-film").addClass("d-none");
            $videoBlock[0].src += "&autoplay=1&mute=1";
            isPlayerReady(player) ? player.playVideo() : queue.push(() => {
                player.playVideo();
            });
        });
    });

    let legacyVideoWrapper = $(".legacy-iframe-wrapper");

    let setImageDimenstions = () => {
        legacyVideoWrapper.each(function () {
            const $this = $(this);
            let videoID = $this.find(".legacy-film").attr("src");
            let parsedID = parseUrl(videoID);
            let parsedAlt = $this.find(".legacy-film").attr("alt");
            let legacyBlockWidth = legacyVideoWrapper.width();
            let legacyBlockHeight = legacyVideoWrapper.height();
            let legacyFilmWrapper = $this.find(".legacy-film-wrapper");

            legacyFilmWrapper.empty();
            $this.find(".overlay-legacy-film").height(legacyBlockHeight);
            $this.find(".overlay-legacy-film").width(legacyBlockWidth);
            return legacyFilmWrapper.append(`<img class="image-video" src="https://i.ytimg.com/vi/${parsedID}/sddefault.jpg" alt="${parsedAlt}" style="width: ${legacyBlockWidth + "px"}; height: ${legacyBlockHeight + "px"};"/>`);
        });
    };

    setImageDimenstions();

    $(window).resize(function () {
        setImageDimenstions();
    });
};


// init Masonry for Instagram gallery image
let initGalleryImage = () => {
    let gridElement = document.querySelector(".grid-instagram-images");
    var grid = new Masonry( gridElement, {
        itemSelector: ".instagram-image-wrapper",
        percentPosition: true,
        columnWidth: ".grid-sizer"
    });
}

let playVideoLanding = () => {
    // get video element id
    let vidOriginalClip = $(".media-container__video-landing").get(0);
    let $modalOverlay = $(".l-overlay");
    let $modalVideo = $("[data-modal-video-landing]").find(".video-layer-content");
    let $closeVideoBtn = $("[data-close-video-landing]");
    let $playBtn = $("[data-video-landing-play]");

    let showVideoLayer = () => {
        vidOriginalClip.pause();
        var $el = $(".media-container__video-landing").clone();
        $modalOverlay.removeClass("d-none").addClass("full-height");
        $modalVideo.append($el).addClass("show");
        $modalVideo.find("video").prop("controls", true);
        $modalVideo.find("video").get(0).play();
    };

    let hideVideoOverlay = () => {
        $modalOverlay.addClass("d-none").removeClass("full-height");
        if ($modalVideo.find("video").get(0)) {
            $modalVideo.find("video").get(0).pause();
            $modalVideo.find("video").get(0).currentTime = 0;
            $modalVideo.find("video").prop("controls", false);
            $modalVideo.removeClass("show").empty();
        }
        vidOriginalClip.play();
    };

    $playBtn.on("click", function () {
        showVideoLayer();
    });

    $closeVideoBtn.on("click touchstart", e => {
        e.preventDefault();
        hideVideoOverlay();
    });

    if ($modalOverlay) {
        $modalOverlay.on("click", function (e) {
            e.preventDefault();
            hideVideoOverlay();
        });
    }
};

// Instagram Block Functionality
let productLaunchInstagramInit = () => {
    let instagramWrapper = document.querySelector(".m-product-launch-section__social-wall-block");

    if (instagramWrapper) {
        let instragramImages = instagramWrapper.querySelectorAll("img");
        let showMoreButton = instagramWrapper.querySelector(".js-show-more");
        let showImagesLimit = 6;

        if (instragramImages.length < showImagesLimit) {
            instagramWrapper.classList.add("d-none");
        }

        if (showMoreButton) {
            showMoreButton.addEventListener("click", (e) => {
                e.preventDefault();

                let hideImages = instagramWrapper.querySelectorAll(".hidden-image");
                $("html, body").animate({
                    scrollTop: $(".hidden-image:first").offset().top - 80
                }, 200);

                if (instragramImages.length > showImagesLimit) {
                    for (var i = 0; i < hideImages.length; i++) {
                        if (i < showImagesLimit) {
                            hideImages[i].classList.remove("hidden-image");
                            hideImages[i].classList.add("fade-in-image");
                        }
                    }
                }

                initGalleryImage();

                let newHideImages = instagramWrapper.querySelectorAll(".hidden-image");

                if (newHideImages.length === 0) {
                    showMoreButton.classList.add("d-none");
                    document.querySelector(".shadow").classList.add("d-none");
                }
            });
        }

        $(window).resize(function () {
            initGalleryImage();
        });

        $(document).ready(function () {
            initGalleryImage();
        });
    }
}
module.exports = {
    checkInView: checkInView,
    playVideoIframeInPopup: playVideoIframeInPopup,
    playVideoIframe: playVideoIframe,
    playVideoLanding: playVideoLanding,
    benefitsBlockInit: benefitsBlockInit,
    productLaunchInstagramInit: productLaunchInstagramInit
};
